






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {RotaSla} from '@/model/resource/RotaSla'
import {InputRotaSlaSchema} from '@/schema/resource/RotaSla/InputRotaSlaSchema'

@Component
export default class PersistRotaSlaView extends Vue {
  @Prop() id1?: string
  @Prop() id2?: string
  @Prop() id3?: string

  @Provide('validator') validator = this.$validator

  schema = new InputRotaSlaSchema()
  rotaSla = new RotaSla()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionPontaSla.listPontaSla()
    this.schema.collectionResponsavel.listResponsavel()
  }

  async populate() {
    const id1 = Number(this.id1) || null
    const id2 = Number(this.id2) || null
    const id3 = Number(this.id3) || null

    if (id1 && id2 && id3) {
      await this.rotaSla.getRotaSla(id1, id2, id3)
    }

    $.await.done('getRotaSla')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.rotaSla.persistRotaSla()
    await Helper.successAndPush('system.success.persist', '/rota-sla/list')
  }
}
